import { useTranslation } from 'react-i18next';
import { FormControl } from '@mui/material';
import { FieldArray } from 'redux-form';
import { requiredArray } from '../../../util/validators';
import React from 'react';
import { DynamicComponentInput, DynamicFormFieldArray, renderDynamicComponent } from './DynamicComponent';
import { FieldNames } from '../../../models/fields/names';
import { DynamicFormFieldArrayType } from '../../../models/options/enums';
import { mortgagesInitialValue } from '../../../util/initial-values';

const mortgageInputs: DynamicComponentInput[] = [
  {
    fieldName  : FieldNames.financialStatementCreditor,
    isOptional : false,
    label      : 'Creditor',
    type       : DynamicFormFieldArrayType.TEXT_INPUT,
  },
  {
    fieldName  : FieldNames.financialStatementCurrentBalance,
    isOptional : false,
    label      : 'Current Balance',
    type       : DynamicFormFieldArrayType.CURRENCY,
  },
  {
    fieldName  : FieldNames.financialStatementMonthlyPayment,
    isOptional : false,
    label      : 'Monthly Payment',
    type       : DynamicFormFieldArrayType.CURRENCY,
  },
  {
    fieldName  : FieldNames.financialStatementMaturityDate,
    isOptional : true,
    label      : 'Maturity Date',
    type       : DynamicFormFieldArrayType.DATE_FUTURE,
  },
  {
    fieldName  : FieldNames.financialStatementLocation,
    isOptional : false,
    label      : 'Property Location',
    type       : DynamicFormFieldArrayType.TEXT_INPUT,
  },
  {
    fieldName  : FieldNames.financialStatementJointAccount,
    isOptional : false,
    label      : 'Is this held jointly',
    type       : DynamicFormFieldArrayType.Y_N_SWITCH_TOGGLE,
  },
];

const mortgageProps: DynamicFormFieldArray = {
  addButtonText : 'Account',
  initialValue  : mortgagesInitialValue,
  inputs        : mortgageInputs,
};

export const MortgagesFFAComponent = ({ ...props }) => {
  const { name, options } = props;
  const { t }    = useTranslation();

  return (
    <FormControl fullWidth>
      <FieldArray
        component = {renderDynamicComponent}
        name      = { name }
        props     = { { dynamicProps: mortgageProps, name, t, options } }
        validate  = {[
          requiredArray([]),
        ]}
      />
    </FormControl>
  );
};
